import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const BatteryModal = ({ shipment_monitor }) => {

  // const batteryData = shipment_monitor.map((monitor) => monitor.battery);

  const batteryData = shipment_monitor
  .filter((monitor) => monitor?.battery !== null && monitor?.battery !== undefined && monitor?.battery !== '')
  .map((monitor) => monitor?.battery);

const xaxisCategories = shipment_monitor
  ? shipment_monitor
      .filter((monitor) => monitor.lat_updated)?.map((monitor) => {
    let ob = monitor.lat_updated.split(" ");  // Split the string by space
    ob[ob.length - 1] = ob[ob.length - 1]  + " GMT";  // Append " GMT" to the last element
    let result = ob.join(" ");  // Join the array back into a string
 
    const date = new Date(monitor.lat_updated + " GMT"); // Adding "GMT" to ensure it's treated as local time
    return result; // Return the Unix timestamp in milliseconds
  }) : [];

  const [batteryChart] = useState({
    options: {
      chart: {
        type: 'line',
        stacked: false,
        zoom: {
          type: 'x',
          enabled: true,
          autoScaleYaxis: true
        },
        toolbar: {
          autoSelected: 'zoom',
          show:false
        } 
      },
      stroke: {
        curve: "straight",
        width: 3,
      },
      markers: {
        size: 4,
        colors: ["#FFFFFF"],
        strokeColors: "#2979FF",
        strokeWidth: 3,
        hover: {
          size: 6,
        },
      },
      colors: ["#2979FF"],
      grid: {
        strokeDashArray: 4,
        borderColor: "#E0E0E0",
      },
      dataLabels: {
        enabled: false
      },
      tooltip: {
        x: {
          format: 'dd-MM-yyyy HH:mm'  // Full date and time format
        }
      },
      xaxis: {
        categories: xaxisCategories,
        tickAmount: 10,
        type: 'datetime',
        format:'HH:mm',
      },
      yaxis: {
        max:100,
        min:0,
        labels: {
          formatter: (value) => `${value}%`,
        },
      },
      annotations: {
        yaxis: [
          {
            y: 0,
            y2: 20,
            fillColor: "#DE1135",
            opacity: 0.2,
          },
        ],
      },
      fill: {
        type: "solid", // Change to "solid" to remove any transparency/shading
        opacity: 1, // Ensure it's fully opaque (no shading)
        colors: ["transparent"], // Make sure no fill color appears
      },
    },
    series: [
      {
        name: "",
        data: batteryData,
      },
    ],
  });
  

  return (
    <>
        <ReactApexChart
            options={batteryChart.options}
            series={batteryChart.series}
            type="line"
            height={340}
          />

          {/* <Flex justify="flex-end">
              <CustomParagraph 
                  text="All times are in CDT time zone."
                  fontSize={12}
                  fontWeight={400}
                  lineHeight={"20px"} 
              />
          </Flex> */}
    </>
  );
};

export default BatteryModal;